import Vue from 'vue';
import VueRouter from 'vue-router';
import store from "./store/store";

import Admin from "./views/invoice/index";
import Login from "./views/login/index";

Vue.use(VueRouter);

const checkAuth = (to, from, next) => {

    if (store.getters.getToken === '' && to.name !== 'login') {
        return next({name: 'login'});
    } else {
        return next();
    }
    
};

const routes = [
    {path: '/login', name: 'login', component: Login, beforeEnter: checkAuth},
    {
        path: '/contractors',
        name: 'contractors',
        component: Admin,
        beforeEnter: checkAuth
    },
    {path: '/*', redirect: '/login'},
]

const router = new VueRouter({mode: 'history', routes})

router.beforeEach((to, from, next) => {

    if (to.name === 'login') {
        return next();
    }

    const localToken = localStorage.getItem('access-token');
    const vuexToken = store.getters.getToken;
    const refreshToken = localStorage.getItem('refresh-token');

    if (!localToken && localToken === '' && !vuexToken && vuexToken === '') {
        return next({name: 'login'});
    } else if (localToken && localToken !== '') {
        store.commit('SET_TOKEN', localToken);
        store.commit('PARSE_TOKEN', localToken);
        

    }
    if (refreshToken && refreshToken !== '') {
        store.commit('SET_REFRESH_TOKEN', refreshToken);
    }
    return next();
});

export default router;
